import { AU_CRS } from './constants';

export const isCrsAborted = (status, statusCode) =>
  status === AU_CRS.STATUS.ABORTED &&
  AU_CRS.ABORTED_STATUS_CODE.includes(statusCode);
export const isCrsFailure = (status, statusCode) =>
  status === AU_CRS.STATUS.FAILURE &&
  AU_CRS.FAILURE_STATUS_CODE.includes(statusCode);
export const isCrsSucceeded = (status, statusCode) =>
  status === AU_CRS.STATUS.SUCCESS &&
  AU_CRS.SUCCESS_STATUS_CODE.includes(statusCode);
